import { Component, OnInit, ViewChild } from '@angular/core';
import { SupplierModel, SupplierSalesContact } from 'app/shared/objects/suppliers';
import { CountryCode, UserService } from 'app/auth/user.service';
import { Area, SmartCitiesHelper } from 'app/shared/objects/cities';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { NgForm } from '@angular/forms';
import { HomeService } from 'app/public/home/home.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { AuthService } from 'app/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SuppliersService } from '../suppliers.service';
import { environment } from 'environments/environment';
import { SolutionModel, TypesOnSolutionHelper } from 'app/shared/objects/solutions';
import {
  TranslatedLanguage
} from 'app/shared/restricted-internationalization/restricted-internationalization.component';
import { InternationalizationService } from 'app/shared/services/internationalization.service';
import { FormIndicatorsService } from 'app/public/form-indicators/form-indicators.service';
import { DecimalPipe } from '@angular/common';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-supplier-single-solution',
  templateUrl: './supplier-single-solution.component.html',
  styleUrls: [
    './supplier-single-solution.component.scss',
    '../internal-supplier.scss'
  ]
})
export class SupplierSingleSolutionComponent implements OnInit {

  public loading: boolean = false;
  public supplier: SupplierModel = new SupplierModel;
  public solution: SolutionModel = new SolutionModel;
  public solutionTranslated: SolutionModel = new SolutionModel;
  public contact: SupplierSalesContact = new SupplierSalesContact;
  public companyTypeOptions: {};
  public countryCodeData: CountryCode[];
  public cities: SimpleLocationModel[];
  public completeCities: SmartCitiesHelper[];
  public employeeQuantities: Array<any> = [];
  public showSearch: boolean;
  public solutionImplemented: string;
  public solutionImplementedItems: any = [];
  public solutionAvailable: string;
  public solutionAvailableItems: any = [];
  public supplierId: string;
  public solutionId: string;
  public tag: string;
  public tagList: string[] = [];
  public availableWorldwide: boolean = false;

  public internationalPhoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];//"(009) 000 000 009999";
  public brazilianPhoneMask8 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];//"(00) 0000-00009";
  public brazilianPhoneMask9 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];//"(00) 00000-0000";
  public yearMask = [/[1-2]/, /\d/, /\d/, /\d/];

  public uploaderImages: SolutionUploader = new SolutionUploader;
  public uploaderDocuments: SolutionUploader = new SolutionUploader;
  public maxFileSize = 35 * 1024 * 1024;

  public availableLanguages: Array<TranslatedLanguage> = [];
  public translatedLanguages: Array<TranslatedLanguage> = [];
  public translatedContent: any = [{}];
  public editingLanguage: string = 'en-US';
  public translatedKeys: string[] = ['description', 'name'];
  public isTranslation: boolean = false;
  public isValidSupplier: boolean;

  public areas: Area[] = [];
  public types: TypesOnSolutionHelper = new TypesOnSolutionHelper();

  public results: Object;
  public searchTerm$ = new Subject<string>();

  @ViewChild('f', { static: true }) f: NgForm;

  constructor(
    public homeService: HomeService,
    public internationalization: InternationalizationService,
    public title: Title,
    private config: ConfigurationService,
    private openService: FormIndicatorsService,
    private userService: UserService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private supplierService: SuppliersService,
    private dp: DecimalPipe,
  ) {
  }

  public get finalPhoneMask(): any {
    if (this.contact.phoneCode == '55') {
      return (this.contact.phoneNumber.length < 15) ? this.brazilianPhoneMask8 : this.brazilianPhoneMask9;
    } else
      return this.internationalPhoneMask;
  }

  ngOnInit() {

    window.scroll({ top: 0, behavior: 'smooth' });

    this.companyTypeOptions = this.config.getCompanyType();
    this.employeeQuantities = this.config.getEmployeeQuantity();

    this.route.params.subscribe((params: Params) => {
      this.supplierId = params[ 'supplierId' ];


      this.solutionId = params[ 'solutionId' ];
      this.solution.solutionId = this.solutionId;

      this.supplierService.getSupplier(this.supplierId).then(response => {
        this.supplier = response[ 'object' ][ 'object' ];

        this.isValidSupplier = this.validSupplier(this.supplier);
        !this.isValidSupplier ?
          this.snackBar.open('Preencha os campos abrigatórios no Cadastro da Empresa.',
            null, {
              duration: 4000
            }) : null;
      });

      this.supplierService.getTypeSolution().then(response => this.types = response[ 'object' ]);

      this.openService.getAreas().then(result => {
        this.areas = result;
      });

      this.supplierService.searchLocation(this.searchTerm$)
        .subscribe(results => {
          this.cities = results[ 'object' ];
        });

      if (!this.isNew()) {

        this.supplierService.getSupplier(this.solutionId).then(response => {

          if (!response || !response[ 'object' ] || !response[ 'object' ][ 'object' ]) {
            this.internationalization.translate.get('configuration/unexpected-error').subscribe((text: string) => {
              this.snackBar.open(text, null, { duration: 3000 });
            });
            this.router.navigate(['/supplier-solutions', this.supplierId]);
            return;
          }

          this.solution = response[ 'object' ][ 'object' ];
          this.availableWorldwide = (this.solution.availableWorldwide != null) ? this.solution.availableWorldwide : false;

          this.startFiles();


          this.translatedContent = response[ 'object' ][ 'languages' ];
          const translatedkeys = Object.keys(this.translatedContent);
          translatedkeys.unshift('en-US');

          this.internationalization.getLanguages().then((data: any) => {
            this.loading = false;
            if (data[ 'count' ]) {
              this.availableLanguages = data[ 'items' ];

              for (let key of translatedkeys) {
                for (var i = 0; i < this.availableLanguages.length; i++) {
                  if (this.availableLanguages[ i ].code == key) {
                    this.translatedLanguages.push(this.availableLanguages[ i ]);
                    this.availableLanguages.splice(i, 1);
                    break;
                  }
                }
              }
            }
          });
        });

      } else {

        this.startFiles();
        this.internationalization.getLanguages().then((data: any) => {
          this.loading = false;
          if (data[ 'count' ]) {
            this.availableLanguages = data[ 'items' ];
          }
        });
      }
    });

    this.title.setTitle('Edit Solution - Bright Cities');

    this.userService.getCountryCodes().then(response => {
      this.countryCodeData = response;
    });

  }

  onSubmit() {

    if (this.isValidSupplier) {
      this.loading = true;
      let controls = this.f.controls;
      let controlKeys = Object.keys(controls);
      for (let control of controlKeys) {
        controls[ control ].markAsTouched();
      }

      if (!this.f.valid) {
        this.loading = false;
        return;
      }

      if (this.editingLanguage === 'en-US') { //É base

        if (this.isNew()) {
          this.solution.solutionId = null;
          this.solution.id = null;
          this.solution.supplierId = this.supplierId;
        }

        this.solution.availableWorldwide = this.availableWorldwide;

        this.supplierService.postSolution(this.solution).then(result => {
          if (result) {
            if (result[ 'success' ]) {
              this.internationalization.translate.get('painel-dashboard/changes-updated-success').subscribe((text: string) => {
                this.snackBar.open(text, null, { duration: 3000 });
              });

              if (this.isNew()) {
                setTimeout(() => {
                  window.scroll({ top: 0, behavior: 'smooth' });
                  this.router.navigate(['/supplier-solutions/', this.supplierId]);
                }, 3000);
              } else {
                window.scroll({ top: 0, behavior: 'smooth' });
              }
            } else {
              window.scroll({ top: 0, behavior: 'smooth' });
              this.snackBar.open(result[ 'message' ], null, { duration: 3000 });
            }
          } else {
            window.scroll({ top: 0, behavior: 'smooth' });
            this.internationalization.translate.get('configuration/unexpected-error').subscribe((text: string) => {
              this.snackBar.open(text, null, { duration: 3000 });
            });
          }
          this.loading = false;
        });

      } else if (this.editingLanguage != 'en-US') { //É tradução
        var translatedObj = {};
        translatedObj[ 'id' ] = this.solution.id;
        translatedObj[ 'solutionId' ] = this.solution.id;
        translatedObj[ 'description' ] = this.solutionTranslated.description;
        translatedObj[ 'name' ] = this.solutionTranslated.name;

        this.supplierService.postSolutionTranslation(translatedObj, this.editingLanguage).then(result => {

          if (result) {
            if (result[ 'success' ]) {
              this.internationalization.translate.get('painel-dashboard/changes-updated-success').subscribe((text: string) => {
                this.snackBar.open(text, null, { duration: 3000 });
              });
              window.scroll({ top: 0, behavior: 'smooth' });
            } else {
              window.scroll({ top: 0, behavior: 'smooth' });
              this.snackBar.open(result[ 'message' ], null, { duration: 3000 });
            }
          } else {
            window.scroll({ top: 0, behavior: 'smooth' });
            this.internationalization.translate.get('configuration/unexpected-error').subscribe((text: string) => {
              this.snackBar.open(text, null, { duration: 3000 });
            });
          }

        });

      } else {
        this.snackBar.open('Fill all fields before send data', null, { duration: 3000 });
        this.loading = false;
      }
    } else {
      this.snackBar.open('Preencha os campos abrigatórios no Cadastro da Empresa.',
        null, {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
    }

  }

  validSupplier(supplier): boolean {
    if (!supplier.name || !supplier.contactName || !supplier.contactEmail || !supplier.phone) {
      return false
    } else {
      return true
    }
  }

  isNew(): boolean {
    return this.solutionId == 'new';
  }

  addTag() {
    if (!this.solution.tags)
      this.solution.tags = [];

    this.tagList.push(this.tag);
    this.solution.tags.push(this.tag);
    this.tag = '';
  }

  removeTag(tag: string) {
    this.solution.tags = this.solution.tags.filter(item => item != tag);
  }

  removeAvailable(tag: string) {
    this.solution.availablePlaces = this.solution.availablePlaces.filter(item => item != tag);
  }

  removeLocation(i: string) {
    this.solution.implementedCities = this.solution.implementedCities.filter(item => item[ 'cityId' ] != i);
    this.solution.implementedCityIds = this.solution.implementedCityIds.filter(item => item != i);
  }

  addLocationImplemented(cityName: string, cityId: string) {
    this.cities = null;
    this.solutionImplemented = null;

    var item = {
      'cityId': cityId,
      'cityName': cityName
    };
    if (this.solution.implementedCities != null) {
      this.solution.implementedCities.push(item);
      this.solution.implementedCityIds.push(cityId);
    } else {
      this.solution.implementedCities = [];
      this.solution.implementedCityIds = [];
      this.solution.implementedCities.push(item);
      this.solution.implementedCityIds.push(cityId);
    }
  }

  addLocationAvailable(name: string) {
    this.cities = null;
    this.solutionAvailable = null;
    if (this.solution.availablePlaces != null) {
      this.solution.availablePlaces.push(name);
    } else {
      this.solution.availablePlaces = [];
      this.solution.availablePlaces.push(name);
    }
  }

  searchCities() {
    setTimeout(() => {
      this.supplierService.getSearchSmartCities(this.solutionImplemented).then(
        response => this.completeCities = response
      );
    }, 300)
  }

  searchGroup() {
    setTimeout(() => {
      this.supplierService.getSearchSmartCities(this.solutionImplemented).then(
        response => this.completeCities = response
      );
    }, 300)
  }

  focusSearch() {
    this.showSearch = true;
  }

  blurSearch() {
    setTimeout(() => {
      this.showSearch = false;
    }, 500);
  }

  onToggleChange() {
    this.availableWorldwide = !this.availableWorldwide;
    this.solution.availablePlaces = [];
    // if (this.availableWorldwide){
    //   document.getElementById("divSolution").setAttribute('hidden', 'true');
    // } else {
    //   document.getElementById("divSolution").removeAttribute('hidden');
    // }
  }

  changeSerachTerm() {
    // this.f.controls["city"].valueChanges
    //   .pipe(
    //     debounceTime(200)
    //   ).subscribe(term => {
    if (this.solutionImplemented != '') {
      this.homeService.getSearchSmartCities(this.solutionImplemented).then(response => {
        // console.log(`` + JSON.stringify(response));
        this.showSearch = true;

        this.cities = response;
      });
    }
    // });
  }

  // Files
  fileOverBase(e: any, type: string = null): void {
    if (type === 'images') {
      this.uploaderImages.hasFile = e;
    } else {
      this.uploaderDocuments.hasFile = e;
    }
  }

  startFiles() {

    this.uploaderImages.upload.onWhenAddingFileFailed =
      (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);

    this.uploaderImages.upload.onBeforeUploadItem = (item) => {
      item.url = environment.apiURL + '/restricted/supplier/uploadImageToS3/' + this.solutionId + '/' + 'solution';
      item.withCredentials = false;
      item.headers = [{
        name: 'Authorization',
        value: 'Bearer ' + this.authService.accessToken
      }];
    }

    this.uploaderImages.upload.onCompleteItem = (item: FileItem, response: any, status: any) => {
      const data = JSON.parse(response);
      this.solution.imageVideos = (this.solution.imageVideos) ? this.solution.imageVideos : [];
      if (data.status === 200 && data.success) {
        this.solution.imageVideos.push({
          url: data.object.url
        });
      } else {
        this.snackBar.open(`Error ${data.status} - ${data.message}`, null, { duration: 3000 });
      }
      item.remove();
    };

    this.uploaderDocuments.upload.onWhenAddingFileFailed =
      (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);

    this.uploaderDocuments.upload.onBeforeUploadItem = (item) => {
      item.url = environment.apiURL + '/restricted/supplier/uploadDocumentToS3/' + this.solutionId + 'solution';
      item.withCredentials = false;
      item.headers = [{
        name: 'Authorization',
        value: 'Bearer ' + this.authService.accessToken
      }];
    }

    this.uploaderDocuments.upload.onCompleteItem = (item: FileItem, response: any, status: any) => {
      const data = JSON.parse(response);
      this.solution.documentUrls = (this.solution.documentUrls) ? this.solution.documentUrls : [];
      this.solution.documentUrls.push(data.object.url);
      item.remove();
    };
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    let errorMessage: string;

    switch (filter.name) {
      case 'fileSize':
        errorMessage = `Maximum upload size exceeded (${item.size} of ${this.maxFileSize} allowed)`;
        break;
      case 'mimeType':
        errorMessage = `Type "${item.type} is not allowed.`;
        break;
      default:
        errorMessage = `Unknown error (filter is ${filter.name})`;
    }

    this.snackBar.open(errorMessage, null, { duration: 3000 });
  }

  removeImage(image: string) {
    this.solution.imageVideos = this.solution.imageVideos.filter(item => item.url !== image);
  }

  removeDoc(doc: string) {
    this.solution.documentUrls = this.solution.documentUrls.filter(item => item !== doc);
  }

  hasImage(filename): boolean {
    if (/\.(jpe?g|png|gif|bmp)$/i.test(filename)) {
      return true;
    } else {
      return false;
    }
  }

  getFileName(url): string {
    if (url == null)
      return 'null';

    const filename = url.substring(url.lastIndexOf('/') + 1);
    return filename;
  }

  hasDocuments(): boolean {
    return !(this.solution.documentUrls == null || this.solution.documentUrls.length == 0 || this.solution.documentUrls[ 0 ] == null)
  }


  //Internationalization
  getOnlyEnglish() {
    return this.availableLanguages.filter(x => x.code == 'en-US');
  }

  addLanguage(item: TranslatedLanguage): void {

    for (var i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[ i ].code == item.code) {
        this.translatedLanguages.push(this.availableLanguages[ i ]);
        this.availableLanguages.splice(i, 1);

        this.translatedContent[ item.code ] = [{}];
        for (var j = 0; j < this.translatedKeys.length; j++) {
          this.translatedContent[ item.code ][ this.translatedKeys[ j ] ] = '';
        }
        break;
      }
    }

    this.editLanguage(item.code);
  }

  editLanguage(code: string): void {
    if (this.editingLanguage != 'en-US') {
      this.translatedContent[ this.editingLanguage ].name = this.solutionTranslated.name;
      this.translatedContent[ this.editingLanguage ].description = this.solutionTranslated.description;
    }

    if (code == 'en-US') {
      this.isTranslation = false;
    } else {
      this.isTranslation = true;

      this.solutionTranslated.name = this.translatedContent[ code ].name;
      this.solutionTranslated.description = this.translatedContent[ code ].description;
    }

    this.editingLanguage = code;
  }

  public maskCostValue(value: number): string {

    var free = 'FREE';
    var more = 'Mais que USD ' + '5.000.000';
    var about = 'Cerca de USD ' + this.dp.transform(value);

    this.internationalization.translate.get('painel-dashboard/cost-free').subscribe((text: string) => {
      free = text;
    });
    this.internationalization.translate.get('painel-dashboard/cost-more').subscribe((text: string) => {
      more = text + '5.000.000';
    });
    this.internationalization.translate.get('painel-dashboard/cost-about').subscribe((text: string) => {
      about = text + this.dp.transform(value);
    });


    if (!value || value == 0) {
      this.solution.cost = 0;
      return free;
    } else if (value > 4800000) {
      this.solution.cost = 5;
      return more;
    } else {

      var c = (value * 5) / (5000000);
      this.solution.cost = Math.ceil(c);

      return about;
    }

  }

  public maskTimeValue(value: number): string {
    var month = 'mês';
    var year = 'ano';
    var months = 'meses';
    var years = 'anos';
    var years = 'anos';
    var about = 'cerca de';
    var morethan = 'mais que';

    var response;

    this.internationalization.translate.get('painel-dashboard/month').subscribe((text: string) => {
      month = text;
    });
    this.internationalization.translate.get('painel-dashboard/year').subscribe((text: string) => {
      year = text;
    });
    this.internationalization.translate.get('painel-dashboard/months').subscribe((text: string) => {
      months = text;
    });
    this.internationalization.translate.get('painel-dashboard/years').subscribe((text: string) => {
      years = text;
    });
    this.internationalization.translate.get('painel-dashboard/about').subscribe((text: string) => {
      about = text;
    });
    this.internationalization.translate.get('painel-dashboard/more-than').subscribe((text: string) => {
      morethan = text;
    });

    if (!value || value == 0) {
      this.solution.time = 0;
      response = '';
    } else if (value > 4000000) {
      this.solution.time = 5;
      response = `${morethan} 5 ${years}`;
    } else {

      var c = (value * 5) / (60);
      this.solution.time = Math.ceil(c);

      if (value == 1)
        response = `1 ${month}`;
      else if (value > 58)
        response = `${morethan} 5 ${years}`;
      else {

        var yearval = Math.floor(value / 12);
        var monthval = Math.ceil(value - (yearval * 12));

        if (yearval == 0)
          response = `${about} ${monthval} ${months}`;
        else if (yearval == 1)
          response = `${about} ${1} ${year}`;
        else if (yearval > 1) {
          if (monthval > 0)
            response = `${about} ${yearval} ${years}, ${monthval} ${months}`;
          else
            response = `${about} ${yearval} ${years}`;

        }

      }
    }

    return response;
  }
}


export class SolutionUploader {
  hasFile: boolean;
  private url = environment.apiURL + '/restricted/supplier/uploadImageToS3/solution';
  upload: FileUploader = new FileUploader({
    url: this.url,
    autoUpload: true,
    method: 'POST',
    isHTML5: true,
    maxFileSize: 35 * 1024 * 1024
  });
}


export class SimpleLocationModel {
  public id: string;
  public name: string;

  constructor(name?: string, id?: string) {
    this.id = id;
    this.name = name;
  }
}
